import config from "@/config";
import errors from "@/errors";
import Vue from "vue";

export default {
  loading: {
    livetv: false,
    gamingsoft: false,
    gameplay: false,
    sagaming: false,
    ctgaming: false,
    evolution: false,
    live22: false,
    minigame: false,
    yeebet: false,
    pgsoft: false,
    pretty: false,
    pragmatic: false,
    pragmaticGameList: false,
    joker: false,
    jokerGameList: false,
    w4d: false,
    prg: false,
    e2: false,
    spp: false,
    jili: false,
    jiliGameList: false,
    uusl: false,
    uuslGameList: false,
    next: false,
    live22: false,
    live22GameList: false,
    wf: false,
    wfGameList: false,
    epw: false,
    epwGameList: false,
    awc: false,
    awcGameList: false
  },

  prg(args) {
    const url = config.prgUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "prg",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("min" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("max" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("bet_type" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("comm_type" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!args.min) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }
      if (!args.max) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }
      if (!args.bet_type) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }
      if (!args.comm_type) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.prg = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.prg = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.value;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.prg = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchLiveTV(args) {
    const url = config.whiteLabel ? config.apiTvUrl() : config.liveTvUrl();
    // console.log(url);
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchLiveTV",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("channel" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("match" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sports" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!args.channel) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }
      if (!args.match) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }
      if (!args.sports) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.livetv = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.livetv = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.livetv = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchGS(args) {
    const url = config.launchGSUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchGS",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("player_id" in args) || !args.player_id) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("password" in args) || !args.password) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.gamingsoft = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.gamingsoft = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.gamingsoft = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchL22(args) {
    const url = config.launchL22Url();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchL22",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("player_id" in args) || !args.player_id) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("password" in args) || !args.password) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.live22 = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.live22 = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.live22 = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchGP(args) {
    const url = config.launchGPUrl();
    // console.log(url);
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchGP",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("player_id" in args) || !args.player_id) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("password" in args) || !args.password) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.gameplay = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.gameplay = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.gameplay = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchSA(args) {
    const url = config.launchSAUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchSA",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args)) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!args.username) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }
      if (!args.sessionid) {
        feedback.status = errors.request.failed;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.sagaming = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.sagaming = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.sagaming = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchCT(args) {
    const url = config.launchCTUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchCT",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.ctgaming = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.ctgaming = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.ctgaming = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchPG(args) {
    const url = config.launchPGUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchPG",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.pretty = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.pretty = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.pretty = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchEvo(args) {
    const url = config.launchEvoUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchEvo",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.evolution = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.evolution = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.evolution = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchYb(args) {
    const url = config.launchYbUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchYb",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.yeebet = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.yeebet = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.yeebet = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchPgs(args) {
    const url = config.launchPgsUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchPgs",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.pgsoft = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.pgsoft = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.pgsoft = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchEsports2(args) {
    const url = config.launchEsports2Url();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchEsports2",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.e2 = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.e2 = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.e2 = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  getPragmaticGameList(args) {
    const url = config.getPragmaticGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getPragmaticGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.pragmaticGameList = true;
        Vue.http.post(url, args).then(
          (res) => {
            // console.log(res);
            this.loading.pragmaticGameList = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.pragmaticGameList = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchPragmatic(args, isLiveCasino) {
    var url = config.launchPragmaticUrl();
    if (isLiveCasino === true) {
      url = config.launchPragmaticCasinoUrl();
    }
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchPragmatic",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.pragmatic = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.pragmatic = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.pragmatic = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchMiniGame(args) {
    const url = config.launchMagUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchMiniGame",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.minigame = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.minigame = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.minigame = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchW4D(args) {
    const url = config.launchW4DUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchW4D",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.w4d = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.w4d = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.w4d = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  getJokerGameList(args) {
    const url = config.getJokerGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getJokerGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.jokerGameList = true;
        Vue.http.post(url, args).then(
          (res) => {
            // console.log(res);
            this.loading.jokerGameList = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.jokerGameList = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchJoker(args) {
    const url = config.launchJokerUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchJoker",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.joker = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.joker = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.joker = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchSimplePlay(args) {
    const url = config.launchSimplePlayUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchSimplePlay",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.spp = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.spp = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.spp = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchJili(args) {
    const url = config.launchJiliUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchJili",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.jili = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.jili = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.jili = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  getJiliGameList(args) {
    const url = config.getJiliGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getJiliGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.jiliGameList = true;
        Vue.http.post(url, args).then(
          (res) => {
            // console.log(res);
            this.loading.jiliGameList = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.jiliGameList = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchUusl(args) {
    const url = config.launchUuslUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchUusl",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.uusl = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.uusl = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.uusl = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  getUuslGameList(args) {
    const url = config.getUuslGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getUuslGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.uuslGameList = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.uuslGameList = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.uuslGameList = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchNextSpin(args) {
    const url = config.launchNextSpinUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchNextSpin",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.next = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.next = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.next = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchDbHash(args) {
    const url = config.launchDbHashUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchDbHash",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.next = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.next = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.next = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchDbPoker(args) {
    const url = config.launchDbPokerUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchDbPoker",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.next = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.next = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.next = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchWowGaming(args) {
    const url = config.launchWowGamingUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchWowGaming",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.next = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.next = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.next = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchAICasino(args) {
    const url = config.launchAICasinoUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchAICasino",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.yeebet = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.yeebet = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.yeebet = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchLive22(args) {
    const url = config.launchLive22Url();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchLive22",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.live22 = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.live22 = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.live22 = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  getLive22GameList(args) {
    const url = config.getLive22GameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getLive22GameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.live22GameList = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.live22GameList = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.live22GameList = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchWf(args) {
    const url = config.launchWfUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchWf",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.wf = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.wf = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.wf = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  getWfGameList(args) {
    const url = config.getWfGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getWfGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.wfGameList = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.wfGameList = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.wfGameList = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchEpw(args) {
    const url = config.launchEpwUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchEpw",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.epw = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.epw = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.epw = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  getEpwGameList(args) {
    const url = config.getEpwGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getEpwGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.epwGameList = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.epwGameList = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.epwGameList = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  launchAwc(args) {
    const url = config.launchAwcUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchAwc",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.awc = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.awc = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.awc = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

  getAwcGameList(args) {
    const url = config.getAwcGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getAwcGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      // if (!("username" in args) || !args.username) {
      //   feedback.status = errors.request.incompleted;
      //   reject(feedback);
      //   canRequest = false;
      // }
      // if (!("sessionid" in args) || !args.sessionid) {
      //   feedback.status = errors.request.incompleted;
      //   reject(feedback);
      //   canRequest = false;
      // }

      if (canRequest == true) {
        this.loading.awcGameList = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.awcGameList = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.awcGameList = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },

};
